import { type Images } from '@neos/app'
import byeByePath from '../../modules/Shared/images/ByeBye.svg'
import clockEvtPath from '../../modules/Shared/images/ClockEvt.svg'
import customsFilterANTPath from '../../modules/Shared/images/CustomsFilterANT.svg'
import customsFilterERRPath from '../../modules/Shared/images/CustomsFilterERR.svg'
import customsFilterSSCPath from '../../modules/Shared/images/CustomsFilterSSC.svg'
import customsStateACCPath from '../../modules/Shared/images/CustomsStateACC.svg'
import customsStateANNULEPath from '../../modules/Shared/images/CustomsStateANNULE.svg'
import customsStateANTPath from '../../modules/Shared/images/CustomsStateANT.svg'
import customsStateBAEPath from '../../modules/Shared/images/CustomsStateBAE.svg'
import customsStateDREPath from '../../modules/Shared/images/CustomsStateDRE.svg'
import customsStateDREACCPath from '../../modules/Shared/images/CustomsStateDREACC.svg'
import customsStateDREREFPath from '../../modules/Shared/images/CustomsStateDREREF.svg'
import customsStateERRORPath from '../../modules/Shared/images/CustomsStateERROR.svg'
import customsStateINVPath from '../../modules/Shared/images/CustomsStateINV.svg'
import customsStateSSCPath from '../../modules/Shared/images/CustomsStateSSC.svg'
import customsStateUnknownPath from '../../modules/Shared/images/CustomsStateUnknown.svg'
import customsStateVALPath from '../../modules/Shared/images/CustomsStateVAL.svg'
import darkLightModePath from '../../modules/Shared/images/DarkLightMode.svg'
import exportLetterPath from '../../modules/Shared/images/ExportLetter.svg'
import flagFrenchPath from '../../modules/Shared/images/FlagFrench.svg'
import flagGBPath from '../../modules/Shared/images/FlagGB.svg'
import gotoLoginPagePath from '../../modules/Shared/images/GotoLoginPage.svg'
import homePath from '../../modules/Shared/images/Home.svg'
import importLetterPath from '../../modules/Shared/images/ImportLetter.svg'
import internalStateED0Path from '../../modules/Shared/images/InternalStateED0.svg'
import internalStateENVPath from '../../modules/Shared/images/InternalStateENV.svg'
import internalStateTAPPPath from '../../modules/Shared/images/InternalStateTAPP.svg'
import internalStateTFACPath from '../../modules/Shared/images/InternalStateTFAC.svg'
import internalStateTSTKPath from '../../modules/Shared/images/InternalStateTSTK.svg'
import internalStateTSTPPath from '../../modules/Shared/images/InternalStateTSTP.svg'
import loadingBluePath from '../../modules/Shared/images/LoadingBlue.svg'
import loadingRotateBluePath from '../../modules/Shared/images/LoadingRotateBlue.svg'
import loadingRotateFixeBluePath from '../../modules/Shared/images/LoadingRotateFixeBlue.svg'
import loadingRotateWhitePath from '../../modules/Shared/images/LoadingRotateWhite.svg'
import loadingWhitePath from '../../modules/Shared/images/LoadingWhite.svg'
import logoACBlancPath from '../../modules/Shared/images/LogoACBlanc.svg'
import logoACBleuPath from '../../modules/Shared/images/LogoACBleu.svg'
import logoBleuFleurPath from '../../modules/Shared/images/LogoBleuFleur.svg'
import messageSentPath from '../../modules/Shared/images/MessageSent.svg'
import needClosePath from '../../modules/Shared/images/NeedClose.svg'
import needExpandPath from '../../modules/Shared/images/NeedExpand.svg'
import noDataPath from '../../modules/Shared/images/NoData.svg'
import notificationBellPath from '../../modules/Shared/images/NotificationBell.svg'
import pointPath from '../../modules/Shared/images/Point.svg'
import reinitializeSSOPath from '../../modules/Shared/images/ReinitializeSSO.svg'
import searchDeclPath from '../../modules/Shared/images/SearchDecl.svg'
import signInPath from '../../modules/Shared/images/SignIn.svg'
import threeVerticalDotLightPath from '../../modules/Shared/images/ThreeVerticalDotLight.svg'
import windowsLogoPath from '../../modules/Shared/images/WindowsLogo.svg'

const images: Images = {
  byeBye: { path: byeByePath, colored: true },
  clear: 'clear',
  clearFilter: 'clearFilter',
  clockEvt: { path: clockEvtPath, colored: true },
  customsFilterANT: { path: customsFilterANTPath, colored: true },
  customsFilterERR: { path: customsFilterERRPath, colored: true },
  customsFilterSSC: { path: customsFilterSSCPath, colored: true },
  customsStateACC: { path: customsStateACCPath, colored: true },
  customsStateANNULE: { path: customsStateANNULEPath, colored: true },
  customsStateANT: { path: customsStateANTPath, colored: true },
  customsStateBAE: { path: customsStateBAEPath, colored: true },
  customsStateDRE: { path: customsStateDREPath, colored: true },
  customsStateDREACC: { path: customsStateDREACCPath, colored: true },
  customsStateDREREF: { path: customsStateDREREFPath, colored: true },
  customsStateERROR: { path: customsStateERRORPath, colored: true },
  customsStateINV: { path: customsStateINVPath, colored: true },
  customsStateSSC: { path: customsStateSSCPath, colored: true },
  customsStateUnknown: { path: customsStateUnknownPath, colored: true },
  customsStateVAL: { path: customsStateVALPath, colored: true },
  darkLightMode: { path: darkLightModePath, colored: true },
  exportLetter: { path: exportLetterPath, colored: true },
  filter: 'filterOutline',
  filterOutline: 'filterOutline',
  flagFrench: { path: flagFrenchPath, colored: true },
  flagGB: { path: flagGBPath, colored: true },
  gotoLoginPage: { path: gotoLoginPagePath, colored: true },
  home: { path: homePath, colored: true },
  importLetter: { path: importLetterPath, colored: true },
  internalStateED0: { path: internalStateED0Path, colored: true },
  internalStateENV: { path: internalStateENVPath, colored: true },
  internalStateTAPP: { path: internalStateTAPPPath, colored: true },
  internalStateTFAC: { path: internalStateTFACPath, colored: true },
  internalStateTSTK: { path: internalStateTSTKPath, colored: true },
  internalStateTSTP: { path: internalStateTSTPPath, colored: true },
  loadingBlue: { path: loadingBluePath, colored: true },
  loadingRotateBlue: { path: loadingRotateBluePath, colored: true },
  loadingRotateFixeBlue: { path: loadingRotateFixeBluePath, colored: true },
  loadingRotateWhite: { path: loadingRotateWhitePath, colored: true },
  loadingWhite: { path: loadingWhitePath, colored: true },
  logoACBlanc: { path: logoACBlancPath, colored: true },
  logoACBleu: { path: logoACBleuPath, colored: true },
  logoBleuFleur: { path: logoBleuFleurPath, colored: true },
  messageSent: { path: messageSentPath, colored: true },
  needClose: { path: needClosePath, colored: true },
  needExpand: { path: needExpandPath, colored: true },
  noData: { path: noDataPath, colored: true },
  notificationBell: { path: notificationBellPath, colored: true },
  point: { path: pointPath, colored: true },
  reinitializeSSO: { path: reinitializeSSOPath, colored: true },
  reset: 'reset',
  searchDecl: { path: searchDeclPath, colored: true },
  signIn: { path: signInPath, colored: true },
  threeVerticalDotLight: { path: threeVerticalDotLightPath, colored: true },
  timelineMarkerDefault: 'circle',
  windowsLogo: { path: windowsLogoPath, colored: true },
}

export default images